import { ref } from 'vue'
import type { PendingApprovalResponse } from './types'

// Tiny cross-page store for the "submitted for approval" banner. Flag-write
// calls that come back 202 (see isPendingApproval in api.ts) call
// showPendingApproval; PendingApprovalBanner renders whatever is here.
export interface PendingApprovalNotice {
  project: string
  amended: boolean
  changeRequest: PendingApprovalResponse['changeRequest']
}

export const pendingApprovalNotice = ref<PendingApprovalNotice | null>(null)

// Bumped whenever change requests are created, approved, or rejected from
// this tab, so listeners (the sidebar badge, FlagDetail's pending markers)
// know to refetch without polling.
export const changeRequestsVersion = ref(0)

export function bumpChangeRequests() {
  changeRequestsVersion.value++
}

let dismissTimer: ReturnType<typeof setTimeout> | undefined

export function showPendingApproval(project: string, res: PendingApprovalResponse) {
  pendingApprovalNotice.value = { project, amended: !!res.amended, changeRequest: res.changeRequest }
  bumpChangeRequests()
  if (dismissTimer) clearTimeout(dismissTimer)
  dismissTimer = setTimeout(() => {
    pendingApprovalNotice.value = null
  }, 8000)
}

export function dismissPendingApproval() {
  if (dismissTimer) clearTimeout(dismissTimer)
  pendingApprovalNotice.value = null
}
